import { useNavigate } from "react-router-dom";

import { Button } from "@icg360/design-system";

import { trackEvent } from "utils";

import styles from "./footer-banner.module.scss";

type FooterBannerProps = {
  bannerText: string;
  bannerButtonText: string;
  bannerLink: string;
  eventName?: string;
};

export const FooterBanner = ({
  bannerText,
  bannerButtonText,
  bannerLink,
  eventName,
}: FooterBannerProps) => {
  const navigate = useNavigate();
  const onClick = () => {
    if (eventName) {
      trackEvent(eventName);
    }
    navigate(bannerLink);
  };

  return (
    <div className={styles.bannerSpacer}>
      <div className={styles.banner}>
        {bannerText}
        <Button
          appearance="secondary"
          data-testid="footer-banner-btn"
          onPress={onClick}
        >
          {bannerButtonText}
        </Button>
      </div>
    </div>
  );
};
